export enum CodeContentActionsEnum {
  SET_CID10 = '@form/SET_CID10',
  SET_SUS = '@form/SET_SUS',
  SET_TUSS = '@form/SET_TUSS',
  SET_INITIALSTATE = '@form/SET_INITIALSTATE',
}
